import { cn } from '@simplywallst/ui-core/next';
import type { ReactNode } from 'react';

export const PositiveNegativeValue = ({
  value,
  children,
}: {
  value: number | null;
  children: ReactNode;
}) => (
  <span
    className={cn(
      'text-xs',
      value === 0 || value === null
        ? 'text-soft'
        : value > 0
          ? 'text-good'
          : 'text-bad'
    )}
  >
    {children}
  </span>
);
